import Header from './src/header.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';
export const ToHeader: SFCWithInstall<typeof Header> = withInstall(Header);
export * from './src/instance';
